import React, {Component} from 'react';
import CustomForm from "../../../shared/components/form/CustomForm";
import {FinishVacationConfig} from "../../../shared/components/form/VacationConfig";

class FinishVacation extends Component {
  constructor(props) {
    super(props);
    let [today] = (new Date()).toISOString().split('T')
    let vacation = props.oit.vacations.find(v => !v.finish);
    this.state = {
      initialValues: {
        ...vacation,
        finish: today
      }
    }
  }
  render() {
    return (
      <div>
        <CustomForm
          config={FinishVacationConfig}
          initialValues={this.state.initialValues}s
          onSubmit={(data) => this.props.onSubmit(data)}
        />
      </div>
    )
  }
}

export default FinishVacation;
